import React from 'react'

import { FeedbackMessage } from '../RegularButtonBox/FeedbackMessage/FeedbackMessage'

import style from './FinishExamButtonBox.module.css'

import { Button } from 'common/components'
import { useAppDispatch, useKeyDown } from 'common/hooks'
import { finishExam } from 'features/exam'

type PropsType = {}

export const FinishExamButtonBox = ({}: PropsType) => {
  const dispatch = useAppDispatch()

  const finishButtonHandler = () => {
    dispatch(finishExam())
  }

  useKeyDown(finishButtonHandler, 'Enter')

  return (
    <div className={style['button-box']}>
      <FeedbackMessage />
      <Button onClick={finishButtonHandler} accent type="button" className={style['finish-button']}>
        Завершить тест
      </Button>
    </div>
  )
}
